import { useMemo } from 'react';

import { useSellerWallets } from '../../hooks/use-seller-wallets';

export const useWalletEligibility = () => {
  const sellerWallets = useSellerWallets();
  return useMemo(() => {
    const hasRegisteredWallet = sellerWallets.some((sellerWallet) => sellerWallet.isSetupComplete);
    const eligibleWallet = sellerWallets.find((sellerWallet) => !sellerWallet.isSetupComplete);
    return {
      isEligible: !!eligibleWallet,
      eligibleWallet,
      walletEligibility: sellerWallets,
      hasRegisteredWallet,
    };
  }, [sellerWallets]);
};
